<template>
  <v-dialog
    v-model="dialog"
    max-width="900"
    content-class="dialog-galleria-calciatori"
  >
    <v-card class="dialog-galleria-calciatori-card navy darken-2">
      <div class="dialog-galleria-calciatori-header navy darken-3 white--text">
        <div class="dialog-galleria-calciatori-heading">
          <div class="dialog-galleria-calciatori-title font-hemi-head">
            GALLERIA CALCIATORI
          </div>
          <div class="dialog-galleria-calciatori-subtitle">
            Questa galleria non serve assolutamente a niente durante l'asta. Ma i nuovi
            avatar meritavano di essere visualizzati piú grandi :)
            <br>PS: Stiamo
            provvedendo ad aggiornare tutti gli avatar: abbi ancora un po' di
            pazienza, per favore.
          </div>
        </div>
        <v-btn icon aria-label="Chiudi galleria" @click="dismiss">
          <v-icon class="white--text">close</v-icon>
        </v-btn>
      </div>

      <div class="dialog-galleria-calciatori-filters navy darken-2">
        <div
          class="dialog-galleria-calciatori-role-filters"
          aria-label="Filtra per ruolo"
        >
          <v-btn
            v-for="ruoloId in Constants.RUOLO"
            :key="ruoloId"
            icon
            small
            :aria-pressed="selectedRuoli.includes(ruoloId)"
            :aria-label="`Filtra ${Constants.RUOLI_NEW[ruoloId].plurale}`"
            @click="toggleRuolo(ruoloId)"
          >
            <span
              class="Ruolo"
              :class="{
                ['Ruolo_' + ruoloId]: true,
                outline: !selectedRuoli.includes(ruoloId),
                selezionato: selectedRuoli.includes(ruoloId),
              }"
            >
              {{ Constants.RUOLI[ruoloId] }}
            </span>
          </v-btn>
        </div>

        <v-text-field
          v-model="searchNome"
          class="dialog-galleria-calciatori-search"
          label="Cerca per nome"
          prepend-inner-icon="search"
          clearable
          dense
          outlined
          hide-details
        ></v-text-field>

        <v-select
          v-model="selectedClub"
          :items="clubOptions"
          class="dialog-galleria-calciatori-club"
          label="Club"
          dense
          outlined
          hide-details
        ></v-select>
      </div>

      <div class="dialog-galleria-calciatori-content">
        <v-carousel
          v-if="calciatoriGallery.length"
          :key="galleryCarouselKey"
          v-model="activeIndex"
          class="dialog-galleria-calciatori-carousel"
          height="100%"
          hide-delimiters
          :continuous="false"
          :cycle="false"
        >
          <v-carousel-item
            v-for="calciatore in calciatoriGallery"
            :key="calciatore.id || calciatore.nid"
          >
            <div class="dialog-galleria-calciatori-slide">
              <calciatore-gallery
                :calciatore="calciatore"
                :mantra="mantra"
              ></calciatore-gallery>
            </div>
          </v-carousel-item>
        </v-carousel>

        <div
          v-if="calciatoriGallery.length"
          class="dialog-galleria-calciatori-counter"
        >
          {{ activeIndex + 1 }} / {{ calciatoriGallery.length }}
        </div>

        <div
          v-else
          class="dialog-galleria-calciatori-empty white--text text-center"
        >
          Nessun calciatore trovato (nel ruolo/i selezionati).
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import Vuex from "vuex";
import db from "../../js/db";
import Config from "../../../config-app/config";
import Constants from "../../js/constants";
import CalciatoreGallery from "../common/CalciatoreGallery";

export default {
  name: "dialog-galleria-calciatori",
  components: {
    CalciatoreGallery,
  },
  data() {
    return {
      Constants,
      dialog: false,
      activeIndex: 0,
      selectedRuoli: Object.values(Constants.RUOLO),
      selectedClub: "all",
      searchNome: "",
      directlySelectedCalciatoreId: null,
    };
  },
  mounted() {
    console.log("--> DialogGalleriaCalciatori ready.");
    db.on("showDialogGalleriaCalciatori", this.show);
  },
  destroyed() {
    console.log("<-- DialogGalleriaCalciatori destroyed.");
    db.off("showDialogGalleriaCalciatori", this.show);
  },
  methods: {
    show(calciatoreId = null) {
      if (Config.AVATAR_OR_FLAG === "avatar") {
        this.directlySelectedCalciatoreId = calciatoreId;

        if (calciatoreId) {
          this.selectedRuoli = Object.values(Constants.RUOLO);
          this.selectedClub = "all";
          this.searchNome = "";
        }

        this.activeIndex = 0;
        this.dialog = true;

        if (calciatoreId) {
          this.$nextTick(() => {
            const selectedCalciatore = this.calciatori[calciatoreId];
            const selectedIndex = this.calciatoriGallery.findIndex(
              (calciatore) =>
                calciatore === selectedCalciatore ||
                String(calciatore.id) === String(calciatoreId)
            );
            this.activeIndex = selectedIndex >= 0 ? selectedIndex : 0;
          });
        }
      }
    },
    dismiss() {
      this.dialog = false;
      this.directlySelectedCalciatoreId = null;
    },
    toggleRuolo(ruoloId) {
      const selectedRuoli = this.selectedRuoli.slice();
      const index = selectedRuoli.indexOf(ruoloId);

      if (index === -1) {
        selectedRuoli.push(ruoloId);
      } else {
        selectedRuoli.splice(index, 1);
      }

      this.selectedRuoli = selectedRuoli;
    },
    normalizeSearchText(value) {
      return String(value || "")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLocaleLowerCase("it");
    },
    hasValidClub(calciatore) {
      return (
        calciatore.ID_Club !== undefined &&
        calciatore.ID_Club !== null &&
        String(calciatore.ID_Club) !== "" &&
        String(calciatore.ID_Club) !== "0"
      );
    },
    isDirectlySelectedCalciatore(calciatore) {
      if (!this.directlySelectedCalciatoreId) return false;

      return (
        calciatore === this.calciatori[this.directlySelectedCalciatoreId] ||
        String(calciatore.id) === String(this.directlySelectedCalciatoreId)
      );
    },
  },
  watch: {
    selectedRuoli() {
      this.activeIndex = 0;
    },
    searchNome() {
      this.activeIndex = 0;
    },
    selectedClub() {
      this.activeIndex = 0;
    },
  },
  computed: {
    mantra() {
      return (
        this.asta_settings.tipo_ruoli === Constants.TIPO_RUOLI.MANTRA
      );
    },
    calciatoriGallery() {
      const searchNome = this.normalizeSearchText(this.searchNome).trim();

      return Object.values(this.calciatori || {})
        .filter((calciatore) => {
          const clubAvailable =
            this.hasValidClub(calciatore) ||
            this.isDirectlySelectedCalciatore(calciatore);
          const ruoloMatch =
            this.selectedRuoli.includes(Number(calciatore.ID_Ruolo));
          const nomeMatch =
            searchNome === "" ||
            this.normalizeSearchText(calciatore.calciatore).includes(searchNome);
          const clubMatch =
            this.selectedClub === "all" ||
            String(calciatore.ID_Club) === this.selectedClub;

          return clubAvailable && ruoloMatch && nomeMatch && clubMatch;
        })
        .sort((a, b) => {
          const quotazioneDiff =
            Number(b.quotazione || 0) - Number(a.quotazione || 0);
          if (quotazioneDiff !== 0) return quotazioneDiff;

          return (a.calciatore || "").localeCompare(
            b.calciatore || "",
            "it",
            {
              sensitivity: "base",
            }
          );
        });
    },
    galleryCarouselKey() {
      return this.calciatoriGallery
        .map((calciatore) => calciatore.id || calciatore.nid)
        .join("|");
    },
    clubOptions() {
      const clubs = Object.values(this.calciatori || {}).reduce(
        (options, calciatore) => {
          if (this.hasValidClub(calciatore) && calciatore.nomeClub) {
            options[String(calciatore.ID_Club)] = calciatore.nomeClub;
          }

          return options;
        },
        {}
      );

      const options = Object.keys(clubs)
        .map((clubId) => ({
          text: clubs[clubId],
          value: clubId,
        }))
        .sort((a, b) =>
          a.text.localeCompare(b.text, "it", { sensitivity: "base" })
        );

      return [{ text: "QUALUNQUE", value: "all" }, ...options];
    },
    ...Vuex.mapGetters(["asta_settings", "calciatori"]),
  },
};
</script>

<style lang="scss" scoped>
.dialog-galleria-calciatori-card {
  display: flex;
  flex-direction: column;
  height: 90vh;
  max-height: 900px;
  overflow: hidden;
}

.dialog-galleria-calciatori-header {
  z-index: 1;
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 14px 20px;
  box-shadow: 0 3px 12px rgb(0 0 0 / 24%);
}

.dialog-galleria-calciatori-heading {
  flex: 1 1 auto;
  min-width: 0;
}

.dialog-galleria-calciatori-title {
  color: white;
  font-size: 24px;
}

.dialog-galleria-calciatori-subtitle {
  margin-top: 2px;
  color: rgb(255 255 255 / 72%);
  font-size: 13px;
}

.dialog-galleria-calciatori-content {
  position: relative;
  flex: 1 1 auto;
  min-height: 0;
  overflow: hidden;
  padding: 16px;
}

.dialog-galleria-calciatori-filters {
  z-index: 1;
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 10px 20px;
  box-shadow: 0 3px 12px rgb(0 0 0 / 16%);
}

.dialog-galleria-calciatori-role-filters {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  gap: 4px;
}

.dialog-galleria-calciatori-role-filters .Ruolo {
  width: 28px;
  height: 28px;
  font-size: 11px;
  transition: transform 0.15s ease;
}

.dialog-galleria-calciatori-role-filters .Ruolo.selezionato {
  transform: scale(1.12);
}

.dialog-galleria-calciatori-search {
  flex: 0 1 260px;
  max-width: 260px;
}

.dialog-galleria-calciatori-club {
  flex: 0 1 180px;
  max-width: 180px;
}

.dialog-galleria-calciatori-search::v-deep fieldset,
.dialog-galleria-calciatori-club::v-deep fieldset {
  border-color: var(--v-navy-base) !important;
}

.dialog-galleria-calciatori-search::v-deep input,
.dialog-galleria-calciatori-search::v-deep .v-label,
.dialog-galleria-calciatori-search::v-deep .v-icon,
.dialog-galleria-calciatori-club::v-deep .v-select__selection,
.dialog-galleria-calciatori-club::v-deep .v-label,
.dialog-galleria-calciatori-club::v-deep .v-icon {
  color: var(--v-navy-lighten2) !important;
}

.dialog-galleria-calciatori-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: rgb(255 255 255 / 66%);
}

.dialog-galleria-calciatori-carousel {
  background: transparent;
}

.dialog-galleria-calciatori-carousel::v-deep .v-window__prev,
.dialog-galleria-calciatori-carousel::v-deep .v-window__next {
  padding: 15px;
  margin:0;
}

.dialog-galleria-calciatori-slide {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 0 56px 30px;
}

.dialog-galleria-calciatori-slide .calciatore-gallery {
  width: 100%;
  max-width: 620px;

  // height: 100%;
  // max-height: 680px;
}

.dialog-galleria-calciatori-counter {
  position: absolute;
  z-index: 2;
  right: 50%;
  bottom: 15px;
  padding: 4px 9px;
  transform: translateX(50%);
  background: rgb(0 0 0 / 28%);
  border-radius: 4px;
  color: rgb(255 255 255 / 72%);
  font-size: 11px;
}

@media (max-width: 600px) {

  .dialog-galleria-calciatori-card {
    height: 86vh;
    max-height: none;
  }

  .dialog-galleria-calciatori-filters {
    flex-wrap: wrap;
    gap: 8px;
    padding: 8px 12px;
  }

  .dialog-galleria-calciatori-search,
  .dialog-galleria-calciatori-club {
    flex: 1 1 0;
    min-width: 0;
    max-width: none;
  }

  .dialog-galleria-calciatori-role-filters {
    flex-basis: 100%;
    justify-content: center;
    gap: 8px;
    margin: 4px 0;
  }

  .dialog-galleria-calciatori-slide .calciatore-gallery {
    height: 100%;
    max-height: 100%;
    margin: 0;
  }

  .dialog-galleria-calciatori-header {
    align-items: flex-start;
    padding: 10px 12px;
  }

  .dialog-galleria-calciatori-title {
    font-size: 19px;
  }

  .dialog-galleria-calciatori-subtitle {
    font-size: 11px;
    line-height: 1.25;
  }

  .dialog-galleria-calciatori-content {
    display: grid;
    grid-template-rows: minmax(0, 1fr) auto;
    padding: 6px;
  }

  .dialog-galleria-calciatori-counter {
    position: static;
    justify-self: center;
    margin-top: 4px;
    transform: none;
  }

  .dialog-galleria-calciatori-slide {
    justify-content: flex-start;
    overflow: hidden;
    padding: 0 10px;
  }
}
</style>
